import { ZmVirtualTable } from '@zoom/zoom-ui-vue3';
import { defineComponent, h } from 'vue';

export default defineComponent({
  name: 'SelectionTable',
  props: {
    data: { type: Array, default: () => [] },
    height: { type: [String, Number], default: 300 },
    keeps: { type: Number, default: 30 },
    'estimate-size': { type: Number, default: 50 },
    'item-size': { type: Number, default: 50 },
    'row-key': { type: String, default: 'id' },
    initSelections: { type: Array, default: () => [] },
  },
  mounted() {
    if (this.initSelections?.length > 0) {
      this.$nextTick(() => {
        const table = this.$refs.virtualTable;
        if (table?.toggleRowSelection) {
          this.initSelections.forEach(item => {
            table.toggleRowSelection(item);
          });
        }
      });
    }
  },
  render() {
    return h(ZmVirtualTable, {
      ref: 'virtualTable',
      ...this.$props,
      ...this.$attrs,
      onSelect: (...args) => this.$emit('select', ...args),
      onSelectAll: (...args) => this.$emit('select-all', ...args),
    }, this.$slots);
  },
});
